module.exports = __webpack_public_path__ + "media/newstyle/images/icon-hasnt-e0ae3f5535394e97cc7ca9eaada06281.svg";